import React from 'react';
import { TagFeedback, TagGeneral } from '@spark';

/**
 * "Fields" row under a model's user prompt (Figma 2099:71135): one chip per
 * dynamic field the prompt references, in order of first appearance. Fields
 * the dataset does not have render in the warning style (Figma 2218:93301).
 *
 * `{{example}}` is the example text, not a dynamic field, so a prompt that
 * only uses it renders nothing here.
 */
const FieldsTagsRow = ({ fields = [], unknown = [] }) => {
    if (fields.length === 0) return null;
    const missing = new Set(unknown);
    return (
        <div className="pg-fields-row" data-testid="pg-fields-row">
            <span className="pg-fields-row__label">Fields</span>
            {fields.map((field) =>
                missing.has(field) ? (
                    <TagFeedback
                        key={field}
                        label={field}
                        variant="warning"
                        showIcon
                        className="pg-fields-tag pg-fields-tag--unknown"
                    />
                ) : (
                    <TagGeneral key={field} label={field} className="pg-fields-tag" />
                )
            )}
        </div>
    );
};

export default FieldsTagsRow;
